import type { AppConfig } from "../../types/appConfig";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";
import type { NewsletterMapping } from "./Newsletter.typed";

export class NewsletterModel {
  zekayAPI: string;
  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }
  async getNewsletterMapping(): Promise<NewsletterMapping> {
    const r = await fetchZekay(this.zekayAPI + "/newsletter/mapping");
    await expectStatuses(r, 200, 204);
    if (r.status === 204) return {};
    return (await r.json()) as NewsletterMapping;
  }
  async updateNewsletterMapping(mapping: NewsletterMapping): Promise<void> {
    const r = await fetchZekay(this.zekayAPI + "/newsletter/mapping", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(mapping),
    });
    await assertResponseOk(r);
  }
}
